const versionRE = /([0-9]*)\.([0-9]*)\.([0-9]*)-([0-9]*)((?:\.)([a-f0-9]*))?/
const semverFields = ['major', 'minor', 'patch']
const semverAndBuildFields = [...semverFields, 'build']

const versionService = {

  parseVersion(version) {
    const buildParts = versionRE.exec(version)
    if (!!buildParts && buildParts.length >= 5) {
      const [, major, minor, patch, build = '00000', , sha] = buildParts
      const semver = `${major}.${minor}.${patch}`
      return { version, major, minor, patch, sha, build, semver }
    }
  },

  sortSemverAndBuild(v1, v2) {
    for (const field of semverAndBuildFields) {
      const result = parseInt(v1[field]) - parseInt(v2[field])
      if (result !== 0) {
        return result
      }
    }

    // Otherwise, just use version
    return v1.version.localeCompare(v2.version)
  },

  sortSemver(v1, v2) {
    for (const field of semverFields) {
      const result = parseInt(v1[field]) - parseInt(v2[field])
      if (result !== 0) {
        return result
      }
    }

    // Otherwise, just use version
    return v1.version.localeCompare(v2.version)
  },

  findSemverUpgradeTargets(versionObject, versions) {
    return versions.filter(v => v.major === versionObject.major && v.minor === versionObject.minor)
  },

  sortVersion(opt1, opt2) {
    const v1 = opt1.name === 'latest' ? 'latest' : versionService.parseVersion(opt1.name)
    const v2 = opt2.name === 'latest' ? 'latest' : versionService.parseVersion(opt2.name)
    if (v1 === v2) {
      return 0
    }
    if (v1 === 'latest') {
      return 1
    }
    if (v2 === 'latest') {
      return -1
    }
    if (!!v1 && !!v2) {
      return versionService.sortSemverAndBuild(v1, v2)
    }
    if (v1) {
      return 1
    }
    if (v2) {
      return -1
    }
    return opt1.name < opt2.name ? -1 : 1
  }
}

export default versionService
